import * as React from 'react'
import { AccountsController, BoardListsController, BoardsController, ContactGroupsController, ContactsController, DealStagesController, DealsController, ExpenseCategoriesController, FinancialYearController, HelpCentersController, NewsCentersController, PlaybooksController, ProjectsController, ProjectTagsController, SequencesController, UsersController, WorkTypesController } from '../../controllers'
import Utils from '../../utilities/Utils'
import CreatableSelect from 'react-select/creatable'
import ReactSelectTheme from './ReactSelectTheme'
import { ThemeConfig } from 'react-select/src/theme'
import { AnyAction, Dispatch } from 'redux'
import { showContactGroupModal, showContactModal, showContactTypeModal, showDealModal, showDealStageModal, showFinancialYearModal, showProjectModal, showProjectTagModal, showUserWorkspaceSettingModal, showWorkTypeModal, showDocumentTagModal, closeTaskModal, closeContactEnrollmentModal, showArticleTagModal, showNewsTagModal, showExpenseCategoryModal } from '../../store/modals/actions'
import { connect } from 'react-redux'
import { WithTranslation, withTranslation } from 'react-i18next'
import { Styles } from 'react-select/src/styles'
import { OptionsType, ValueType } from 'react-select/src/types'
import UserworkspaceSettingHelper from '../../helpers/UserWorkspaceSettingHelper'
import deepEqual from 'deep-equal'
import { ContactType, ExpenseCategory, ResourceCreatablePowerSelectType, UserWorkspaceSettingScope } from '../../types'
import { SelectComponents } from 'react-select/src/components'
import ContactSelectComponents from '../Powerselect/ContactSelectComponents'
import ContactEmailIndicatorSelectComponents from '../Powerselect/ContactEmailIndicatorSelectComponents'
import UserWorkspaceSettingHelper from '../../helpers/UserWorkspaceSettingHelper'
import ResourceSelectComponents from '../Powerselect/ResourceSelectComponents'
import DocumentTagsController from '../../controllers/DocumentTagsController'
import DocumentTagSelectComponents from '../Powerselect/DocumentTagSelectComponents'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import RouteHelper from '../../helpers/RouteHelper'
import ERoute from '../../ERoute'
import ArticleTagsController from '../../controllers/ArticleTagsController'
import ArticleTagSelectComponents from '../Powerselect/ArticleTagSelectComponents'
import ProjectSelectComponents from '../Powerselect/ProjectSelectComponents'
import NewsTagsController from '../../controllers/NewsTagsController'
import NewsTagSelectComponents from '../Powerselect/NewsTagSelectComponents'
import ProjectTagSelectComponent from '../Powerselect/ProjectTagSelectComponents'
import ExpenseCategorySelectComponents from '../Powerselect/ExpenseCategorySelectComponents'
import ExpenseCategoryHelper from '../../helpers/ExpenseCategoryHelper'

interface IDispatchToProps {
	showContactModal: typeof showContactModal
	showProjectModal: typeof showProjectModal
	showProjectTagModal: typeof showProjectTagModal
	showUserWorkspaceSettingModal: typeof showUserWorkspaceSettingModal
	showDealModal: typeof showDealModal
	showDealStageModal: typeof showDealStageModal
	showContactGroupModal: typeof showContactGroupModal
	showContactTypeModal: typeof showContactTypeModal
	showWorkTypeModal: typeof showWorkTypeModal
	showDocumentTagModal: typeof showDocumentTagModal
	showArticleTagModal: typeof showArticleTagModal
	showNewsTagModal: typeof showNewsTagModal
	showFinancialYearModal: typeof showFinancialYearModal
	showExpenseCategoryModal: typeof showExpenseCategoryModal
	closeTaskModal: typeof closeTaskModal
	closeContactEnrollmentModal: typeof closeContactEnrollmentModal
}

type IProps = {
	type: ResourceCreatablePowerSelectType
	value?: string | string[]
	isDisabled?: boolean
	isClearable?: boolean
	// @ts-ignore
	isValidNewOption?: (inputValue: string, value: ValueType<{ label: string; value: string }>, options: OptionsType<{ label: string; value: string }>) => boolean
	params?: { [key: string]: any }
	createParams?: object | any
	onChange?: (value?: string | string[], resource?: any) => void
	theme?: ThemeConfig
	// @ts-ignore
	styles?: Partial<Styles>
	placeholder?: string
	isMulti?: boolean
	// expense_category: allow selecting a parent category through its group heading (selects all child categories when isMulti)
	isGroupHeadingSelectable?: boolean
} & IDispatchToProps & WithTranslation & RouteComponentProps


interface IState {
	valueResources: any[]
	defaultResources: any[]
	searchResources: any[]
	isLoadingValueResource: boolean
	isLoadingDefaultResources: boolean
	isLoadingSearchResources: boolean
	searchValue: string
}

class ResourceCreatablePowerSelectClass extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)

		this.state = {
			valueResources: null,
			defaultResources: [],
			searchResources: [],
			isLoadingValueResource: false,
			isLoadingDefaultResources: false,
			isLoadingSearchResources: false,
			searchValue: '',
		}

		this.getResources = this.getResources.bind(this)
		this.getOptions = this.getOptions.bind(this)
		this.getOptionFromResource = this.getOptionFromResource.bind(this)
		this.fetchValueResources = this.fetchValueResources.bind(this)
		this.fetchDefaultResources = this.fetchDefaultResources.bind(this)
		this.fetchDefaultResourcesDebounced = Utils.debounce(this.fetchDefaultResources, 250, false)
		this.fetchSearchResources = this.fetchSearchResources.bind(this)
		this.fetchSearchResourcesDebounced = Utils.debounce(this.fetchSearchResources, 250, false)
		this.onResourceModalSubmit = this.onResourceModalSubmit.bind(this)
		this.onResourceModalDelete = this.onResourceModalDelete.bind(this)
		this.onExpenseCategoryModalSubmit = this.onExpenseCategoryModalSubmit.bind(this)
		this.onChange = this.onChange.bind(this)
		this.onInputChange = this.onInputChange.bind(this)
		this.onInputFocus = this.onInputFocus.bind(this)
		this.onCreateOption = this.onCreateOption.bind(this)
		this.onAddOption = this.onAddOption.bind(this)
		this.onEditOption = this.onEditOption.bind(this)
		this.formatCreateLabel = this.formatCreateLabel.bind(this)
		this.isValidNewOption = this.isValidNewOption.bind(this)
		this.getOptionFromResource = this.getOptionFromResource.bind(this)
		this.getComponents = this.getComponents.bind(this)
		this.getUpsertModeEnabled = this.getUpsertModeEnabled.bind(this)
		this.onGroupHeadingClick = this.onGroupHeadingClick.bind(this)
		this.isOptionSelected = this.isOptionSelected.bind(this)
		this.filterOption = this.filterOption.bind(this)
	}

	componentDidMount() {
		if (this.props.value) this.fetchValueResources()
	}

	componentDidUpdate(prevProps: IProps) {
		if (!deepEqual(this.props.value, prevProps.value)) {
			this.fetchValueResources()
		}

		if (!deepEqual(this.props.params, prevProps.params)) {
			this.fetchDefaultResourcesDebounced()
		}
	}

	async fetchValueResources() {
		const { type, value, params } = this.props

		// If value set fetch remote resource
		if (this.props.value) {
			try {
				this.setState({ isLoadingValueResource: true })

				let valueResources = []
				const idValues = Array.isArray(value) ? value : [value]

				if (idValues.length === 0) {
					this.setState({ valueResources: null, isLoadingValueResource: false })
					return
				}

				switch (type) {
					case 'company':
					case 'company_with_email':
						const { contacts: companies } = await ContactsController.getContacts({ 'id[in]': idValues, type: ContactType.COMPANY })
						valueResources = companies
						break
					case 'person':
					case 'person_with_email':
						const { contacts: people } = await ContactsController.getContacts({ 'id[in]': idValues, type: ContactType.PERSON })
						valueResources = people
						break
					case 'contact':
					case 'contact_with_email':
						const { contacts } = await ContactsController.getContacts({ 'id[in]': idValues })
						valueResources = contacts
						break
					case 'contact_group':
						const { contact_groups } = await ContactGroupsController.getContactGroups({ 'id[in]': idValues })
						valueResources = contact_groups
						break
					case 'project':
						const { projects } = await ProjectsController.getProjects({ 'id[in]': idValues })
						valueResources = projects
						break
					case 'project_tag':
						const { project_tags } = await ProjectTagsController.getProjectTags({ 'id[in]': idValues })
						valueResources = project_tags
						break
					case 'user':
						const { users } = await UsersController.getUsers({ 'users.id[in]': idValues })
						valueResources = users
						break
					case 'deal_stage':
						const { deal_stages } = await DealStagesController.getDealStages({ 'id[in]': idValues })
						valueResources = deal_stages
						break
					case 'deal':
						const { deals } = await DealsController.getDeals({ 'id[in]': idValues })
						valueResources = deals
						break
					case 'work_type':
						const { work_types } = await WorkTypesController.getWorkTypes({ 'id[in]': idValues })
						valueResources = work_types
						break
					case 'board':
						const { boards } = await BoardsController.getBoards({ 'id[in]': idValues })
						valueResources = boards
						break
					case 'board_list':
						if (!params.board_id) {
							valueResources = []
						} else {
							const { board_lists } = await BoardListsController.getBoardLists(params.board_id, { 'id[in]': idValues })
							valueResources = board_lists
						}
						break
					case 'document_tag':
						const { document_tags } = await DocumentTagsController.getDocumentTags({ 'id[in]': idValues })
						valueResources = document_tags
						break
					case 'playbook':
						const { playbooks } = await PlaybooksController.getPlaybooks({ 'id[in]': idValues })
						valueResources = playbooks
						break
					case 'sequence':
						const { sequences } = await SequencesController.getSequences({ 'id[in]': idValues })
						valueResources = sequences
						break
					case 'account':
						const { accounts } = await AccountsController.getAccounts({ 'id[in]': idValues })
						valueResources = accounts
						break
					case 'help_center':
						const { help_centers } = await HelpCentersController.getHelpCenters({ 'id[in]': idValues })
						valueResources = help_centers
						break
					case 'news_center':
						const { news_centers } = await NewsCentersController.getNewsCenters({ 'id[in]': idValues })
						valueResources = news_centers
						break
					case 'article_tag':
						if (!params.help_center_id) {
							valueResources = []
						} else {
							const { article_tags } = await ArticleTagsController.getArticleTags(params.help_center_id, { 'id[in]': idValues })
							valueResources = article_tags
						}
						break
					case 'news_tag':
						if (!params.news_center_id) {
							valueResources = []
						} else {
							const { news_tags } = await NewsTagsController.getNewsTags(params.news_center_id, { 'id[in]': idValues })
							valueResources = news_tags
						}
						break
					case 'financial_year':
						const { financial_years: valueFinancialYears } = await FinancialYearController.getFinancialYears({ 'id[in]': idValues })
						valueResources = valueFinancialYears
						break
					case 'expense_category':
						const valueExpenseCategories: ExpenseCategory[] = await ExpenseCategoriesController.getCategories(params)
						valueResources = valueExpenseCategories.filter(category => idValues.includes(category.id))
						break
					default:
						throw Error(`[fetchValueResource] invalid type ${type} given`)
				}

				this.setState({ valueResources: valueResources })
			} catch (ex) {
				console.error(ex)
				this.setState({ valueResources: null })
			} finally {
				this.setState({ isLoadingValueResource: false })
			}
			// If not set set value resource to null
		} else {
			this.setState({ valueResources: null })
		}
	}

	fetchDefaultResourcesDebounced() {
		this.fetchDefaultResources().catch(console.error)
	}

	async fetchDefaultResources() {
		const { type, params } = this.props

		try {
			this.setState({ isLoadingDefaultResources: true })

			let defaultResources = []

			switch (type) {
				case 'company':
				case 'company_with_email':
					const { contacts: companies } = await ContactsController.getContacts({ ...params, type: ContactType.COMPANY })
					defaultResources = companies
					break
				case 'person':
				case 'person_with_email':
					const { contacts: people } = await ContactsController.getContacts({ ...params, type: ContactType.PERSON })
					defaultResources = people
					break
				case 'contact':
				case 'contact_with_email':
					if (params?.contact_id) {
						// Make a copy
						const customParams = { ...params }

						// Delete contact id
						delete customParams.contact_id

						// Apply filters + id[in]
						const { contacts: selfContacts } = await ContactsController.getContacts({ ...customParams, 'id[in]': params.contact_id })

						defaultResources = [...selfContacts, ...defaultResources]
					}
					const { contacts } = await ContactsController.getContacts({ ...params })

					defaultResources = [...defaultResources, ...contacts]
					break
				case 'contact_group':
					const { contact_groups } = await ContactGroupsController.getContactGroups(params)
					defaultResources = contact_groups
					break
				case 'project':
					const { projects } = await ProjectsController.getProjects(params)
					defaultResources = projects
					break
				case 'project_tag':
					const { project_tags } = await ProjectTagsController.getProjectTags(params)
					defaultResources = project_tags
					break
				case 'user':
					const { users } = await UsersController.getUsers(params)
					defaultResources = users
					break
				case 'deal_stage':
					const { deal_stages } = await DealStagesController.getDealStages(params)
					defaultResources = deal_stages
					break
				case 'deal':
					const { deals } = await DealsController.getDeals(params)
					defaultResources = deals
					break
				case 'work_type':
					const { work_types } = await WorkTypesController.getWorkTypes(params)
					defaultResources = work_types
					break
				case 'board':
					const { boards } = await BoardsController.getBoards(params)
					defaultResources = boards
					break
				case 'board_list':
					if (!params.board_id) {
						defaultResources = []
					} else {
						const { board_lists } = await BoardListsController.getBoardLists(params.board_id, params)
						defaultResources = board_lists
					}

					break
				case 'document_tag':
					const { document_tags } = await DocumentTagsController.getDocumentTags(params)
					defaultResources = document_tags
					break
				case 'playbook':
					const { playbooks } = await PlaybooksController.getPlaybooks(params)
					defaultResources = playbooks
					break
				case 'sequence':
					const { sequences } = await SequencesController.getSequences(params)
					defaultResources = sequences
					break
				case 'account':
					const { accounts } = await AccountsController.getAccounts(params)
					defaultResources = accounts
					break
				case 'help_center':
					const { help_centers } = await HelpCentersController.getHelpCenters(params)
					defaultResources = help_centers
					break
				case 'news_center':
					const { news_centers } = await NewsCentersController.getNewsCenters(params)
					defaultResources = news_centers
					break
				case 'article_tag':
					if (!params?.help_center_id) {
						defaultResources = []
					} else {
						const { article_tags } = await ArticleTagsController.getArticleTags(params.help_center_id, params)
						defaultResources = article_tags
					}
					break
				case 'news_tag':
					if (!params?.news_center_id) {
						defaultResources = []
					} else {
						const { news_tags } = await NewsTagsController.getNewsTags(params.news_center_id, params)
						defaultResources = news_tags
					}
					break
				case 'financial_year':
					const { financial_years: defaultFinancialYears } = await FinancialYearController.getFinancialYears(params)
					defaultResources = defaultFinancialYears
					break
				case 'expense_category':
					defaultResources = await ExpenseCategoriesController.getCategories(params)
					break
				default:
					throw Error(`[fetchDefaultResources] invalid type ${type} given`)
			}

			this.setState({ defaultResources: defaultResources })
		} catch (ex) {
			console.error(ex)

			this.setState({ defaultResources: null })
		} finally {
			this.setState({ isLoadingDefaultResources: false })
		}
	}

	async fetchSearchResources(inputValue: string) {
		const { type, params } = this.props

		let searchResources = []

		try {
			this.setState({ isLoadingSearchResources: true })

			switch (type) {
				case 'company':
				case 'company_with_email':
					const { contacts: searchNameCompanies } = await ContactsController.getContacts({ ...params, type: ContactType.COMPANY, 'name[cont]': inputValue })
					const { contacts: searchAliasCompanies } = await ContactsController.getContacts({ ...params, type: ContactType.COMPANY, 'alias[cont]': inputValue })

					searchResources = [...searchNameCompanies, ...searchAliasCompanies]
					break
				case 'person':
				case 'person_with_email':
					const { contacts: searchNamePeople } = await ContactsController.getContacts({ ...params, type: ContactType.PERSON, 'name[cont]': inputValue })
					const { contacts: searchAliasPeople } = await ContactsController.getContacts({ ...params, type: ContactType.PERSON, 'alias[cont]': inputValue })

					searchResources = [...searchNamePeople, ...searchAliasPeople]
					break
				case 'contact':
				case 'contact_with_email':
					const { contacts: searchNameContacts } = await ContactsController.getContacts({ ...params, 'name[cont]': inputValue })
					const { contacts: searchAliasContacts } = await ContactsController.getContacts({ ...params, 'alias[cont]': inputValue })

					searchResources = [...searchNameContacts, ...searchAliasContacts]
					break
				case 'contact_group':
					const { contact_groups: searchContactGroups } = await ContactGroupsController.getContactGroups({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchContactGroups]
					break
				case 'project':
					const { projects } = await ProjectsController.getProjects({ ...params, 'name[cont]': inputValue })

					searchResources = projects

					break
				case 'project_tag':
					const { project_tags: searchProjectTags } = await ProjectTagsController.getProjectTags({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchProjectTags]
					break
				case 'user':
					const { users } = await UsersController.getUsers({ ...params, 'name[cont]': inputValue })

					searchResources = users
					break
				case 'deal_stage':
					const { deal_stages: searchNameDealStages } = await DealStagesController.getDealStages({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchNameDealStages]
					break
				case 'deal':
					const { deals: searchDeals } = await DealsController.getDeals({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchDeals]
					break
				case 'work_type':
					const { work_types: searchWorkTypes } = await WorkTypesController.getWorkTypes({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchWorkTypes]
					break
				case 'board':
					const { boards: searchBoards } = await BoardsController.getBoards({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchBoards]
					break
				case 'board_list':
					if (!params.board_id) {
						searchResources = []
					} else {
						const { board_lists: searchBoardLists } = await BoardListsController.getBoardLists(params.board_id, { ...params, 'name[cont]': inputValue })
						searchResources = [...searchBoardLists]
					}
					break
				case 'document_tag':
					const { document_tags: searchDocumentTags } = await DocumentTagsController.getDocumentTags({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchDocumentTags]
					break
				case 'playbook':
					const { playbooks: searchPlaybooks } = await PlaybooksController.getPlaybooks({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchPlaybooks]
					break
				case 'sequence':
					const { sequences: searchSequences } = await SequencesController.getSequences({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchSequences]
					break
				case 'account':
					const { accounts: searchAccounts } = await AccountsController.getAccounts({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchAccounts]
					break
				case 'help_center':
					const { help_centers: searchHelpCenters } = await HelpCentersController.getHelpCenters({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchHelpCenters]
					break
				case 'news_center':
					const { news_centers: searchNewsCenters } = await NewsCentersController.getNewsCenters({ ...params, 'name[cont]': inputValue })

					searchResources = [...searchNewsCenters]
					break
				case 'article_tag':
					if (!params.help_center_id) {
						searchResources = []
					} else {
						const { article_tags: searchArticleTags } = await ArticleTagsController.getArticleTags(params.help_center_id, { ...params, 'name[cont]': inputValue })
						searchResources = [...searchArticleTags]
					}
					break
				case 'news_tag':
					if (!params.news_center_id) {
						searchResources = []
					} else {
						const { news_tags: searchNewsTags } = await NewsTagsController.getNewsTags(params.news_center_id, { ...params, 'name[cont]': inputValue })
						searchResources = [...searchNewsTags]
					}
					break
				case 'financial_year':
					const { financial_years: searchFinancialYears } = await FinancialYearController.getFinancialYears({ ...params, 'name[cont]': inputValue })
					searchResources = [...searchFinancialYears]
					break
				case 'expense_category':
					// All categories are loaded as default resources, searching happens client side (see filterOption)
					searchResources = []
					break
				default:
					throw Error(`[fetchSearchResources] Unsupported resource type ${type} given`)
			}

			this.setState({ searchResources: searchResources })
		} catch (ex) {
			console.error(ex)

			this.setState({ searchResources: null })
		} finally {
			this.setState({ isLoadingSearchResources: false })
		}
	}

	fetchSearchResourcesDebounced(inputValue: string) {
		this.fetchSearchResources(inputValue).catch(console.error)
	}

	getSelectedResource() {
		return this.state.valueResources
	}

	getResources() {
		const { valueResources, defaultResources, searchResources, searchValue } = this.state

		let resources = []

		if (valueResources) {
			resources = [...valueResources, ...resources]
		}

		// Add default resources
		resources = [...resources, ...defaultResources]

		// Add search resources
		resources = [...resources, ...searchResources]

		return resources
			// Remove undefined values
			.filter(Boolean)
			// Get unique values
			.reduce<Array<any>>((uniqueResources, o) => {
				if (!uniqueResources.some(obj => obj.id === o.id)) {
					uniqueResources.push(o);
				}
				return uniqueResources;
			}, [])
	}

	getOptions(): any[] {
		const { type } = this.props

		if (type === 'expense_category') {
			return this.getExpenseCategoryGroupedOptions()
		} else if (type === 'board_list') {
			return this
				.getResources()
				.sort((a, b) => a.position - b.position)
				.map(resource => this.getOptionFromResource(resource))
		} else {
			return this
				.getResources()
				.map(resource => this.getOptionFromResource(resource))
		}
	}

	getExpenseCategoryGroupedOptions() {
		const { defaultResources } = this.state

		// Keep the same ordering as the expense modal (ExpenseCategoryHelper.getCategoryOptions), which is the API ordering.
		// getResources() puts selected categories first, so order by the fetched categories and append any not (yet) fetched.
		const fetchedCategories: ExpenseCategory[] = defaultResources || []
		const categories: ExpenseCategory[] = [
			...fetchedCategories,
			...this.getResources().filter(resource => !fetchedCategories.some(category => category.id === resource.id)),
		]

		// Use the same grouping as the expense modal, enriched with the category resource for the select components
		return ExpenseCategoryHelper
			.getCategoryOptions(categories)
			.map(group => ({
				...group,
				category: categories.find(category => category.id === group.value),
				options: group.options.map(option => {
					// Placeholder (parent without children) is labelled after its parent so searching on it keeps the group visible
					if (option.placeholder) return { ...option, label: group.label }

					return {
						...option,
						category: categories.find(category => category.id === option.value),
						parentLabel: group.label,
					}
				}),
			}))
	}

	getSelectedOptions() {
		const { type, value } = this.props

		if (type === 'expense_category') {
			const categories: ExpenseCategory[] = this.getResources()

			if (Array.isArray(value)) {
				return categories
					.filter(category => value.includes(category.id))
					// Child categories are represented by their parent when it is selected
					.filter(category => !category.parent_id || !value.includes(category.parent_id))
					.map(category => this.getOptionFromResource(category))
			} else {
				const category = categories.find(category => category.id === value)
				return category ? this.getOptionFromResource(category) : null
			}
		}

		const options = this.getOptions()

		if (Array.isArray(value)) {
			return value.map(id => options.find(option => option.value === id))
		} else {
			return options.find(option => option.value === value)
		}
	}

	getOptionFromResource(resource: any) {
		const { type } = this.props

		switch (type) {
			case 'contact':
			case 'contact_with_email':
			case 'company':
			case 'company_with_email':
			case 'person':
			case 'person_with_email':
				return {
					label: resource.alias ? `${resource.name} (${resource.alias})` : resource.name,
					value: resource.id,
					contact: resource
				}
			case 'project':
				return { label: resource.name, value: resource.id }
			case 'project_tag':
				return { label: resource.name, value: resource.id }
			case 'user':
				return { label: resource.name ? `${resource.name} (${resource.email})` : resource.email, value: resource.id }
			case 'contact_group':
				return { label: resource.name, value: resource.id }
			case 'deal_stage':
				return { label: resource.name, value: resource.id }
			case 'deal':
				return { label: resource.name, value: resource.id }
			case 'work_type':
				return { label: resource.name, value: resource.id }
			case 'board':
				return { label: resource.name, value: resource.id }
			case 'board_list':
				return { label: resource.name, value: resource.id }
			case 'document_tag':
				return { label: resource.name, value: resource.id, document_tag: resource }
			case 'playbook':
				return { label: resource.name, value: resource.id }
			case 'sequence':
				return { label: resource.name, value: resource.id }
			case 'account':
				return { label: `${resource.name} (${resource.reference})`, value: resource.id }
			case 'help_center':
				return { label: resource.name, value: resource.id }
			case 'news_center':
				return { label: resource.name, value: resource.id }
			case 'article_tag':
				return { label: resource.name, value: resource.id }
			case 'news_tag':
				return { label: resource.name, value: resource.id }
			case 'financial_year':
				return { label: resource.name, value: resource.id }
			case 'expense_category':
				return { label: resource.name, value: resource.id, category: resource }
			default:
				throw Error(`[getOption] Unsupported resource type ${type} given`)
		}
	}

	onChange(option, actionMeta?) {
		const { type, isMulti, onChange } = this.props

		if (type === 'expense_category' && isMulti && actionMeta) {
			this.onExpenseCategoryMultiChange(actionMeta)
		} else if (isMulti) {
			const newValues: string[] = option ? option.map(o => o.value) : null

			const resources = this.getResources()
			let valueResources = null

			if (newValues && newValues.length > 0) {
				valueResources = newValues.map(newValue => resources.find(resource => resource.id === newValue))
			}

			onChange(newValues, valueResources)
		} else {
			const newValue = option ? option.value : null

			const resources = this.getResources()
			let valueResource = null

			if (newValue) valueResource = resources.find(resource => resource.id === newValue)

			onChange(newValue, valueResource)
		}
	}

	getCategoryWithChildIds(categoryId: string): string[] {
		const categories: ExpenseCategory[] = this.getResources()

		return [categoryId, ...categories.filter(category => category.parent_id === categoryId).map(category => category.id)]
	}

	setExpenseCategoryValues(values: string[]) {
		const resources = this.getResources()
		const uniqueValues = Array.from(new Set(values))
		const valueResources = uniqueValues.map(value => resources.find(resource => resource.id === value)).filter(Boolean)

		this.props.onChange(uniqueValues, valueResources.length > 0 ? valueResources : null)
	}

	onExpenseCategoryMultiChange(actionMeta) {
		const value = (this.props.value || []) as string[]

		switch (actionMeta.action) {
			case 'select-option':
				if (actionMeta.option?.value) this.setExpenseCategoryValues([...value, actionMeta.option.value])
				break
			case 'deselect-option': {
				// Deselecting a child category also deselects its parent, as not all children are selected anymore
				const category = this.getResources().find(resource => resource.id === actionMeta.option?.value)
				this.setExpenseCategoryValues(value.filter(id => id !== category?.id && id !== category?.parent_id))
				break
			}
			case 'remove-value':
			case 'pop-value': {
				if (!actionMeta.removedValue) return
				// Removing a parent category also removes its child categories
				const categoryIds = this.getCategoryWithChildIds(actionMeta.removedValue.value)
				this.setExpenseCategoryValues(value.filter(id => !categoryIds.includes(id)))
				break
			}
			case 'clear':
				this.setExpenseCategoryValues([])
				break
		}
	}

	onGroupHeadingClick(groupValue: string) {
		const { type, isMulti, value, onChange, isGroupHeadingSelectable } = this.props

		if (type !== 'expense_category' || !isGroupHeadingSelectable) return

		if (isMulti) {
			const values = (value || []) as string[]
			const categoryIds = this.getCategoryWithChildIds(groupValue)

			// Selecting a parent category selects all of its child categories
			if (values.includes(groupValue)) {
				this.setExpenseCategoryValues(values.filter(id => !categoryIds.includes(id)))
			} else {
				this.setExpenseCategoryValues([...values, ...categoryIds])
			}
		} else {
			onChange(groupValue, this.getResources().find(resource => resource.id === groupValue))
		}
	}

	isOptionSelected(option): boolean {
		const { value } = this.props

		if (!option?.value) return false

		return Array.isArray(value) ? value.includes(option.value) : value === option.value
	}

	filterOption(option: { label: string, value: string, data: any }, inputValue: string): boolean {
		if (option.data?.__isNew__) return true

		const search = inputValue.toLowerCase()

		// Placeholders (parent categories without children) must pass the filter, otherwise react-select hides the whole group.
		// They render nothing and are disabled, only the group heading shows.
		if (search === '') return true

		// Match on the parent category label as well, so searching a parent shows all of its children
		return [option.label, option.data?.parentLabel]
			.filter(Boolean)
			.some(label => label.toLowerCase().includes(search))
	}

	onInputChange(inputValue: string) {
		const { searchValue } = this.state
		if (inputValue !== searchValue) {
			this.fetchSearchResourcesDebounced(inputValue)
			this.setState({ searchValue: inputValue })
		}
	}

	onInputFocus() {
		this.fetchDefaultResourcesDebounced()
	}

	async onCreateOption(inputValue: string) {
		const {
			type,
			showContactTypeModal,
			showContactModal,
			showProjectModal,
			showProjectTagModal,
			showDealModal,
			showContactGroupModal,
			showWorkTypeModal,
			showDocumentTagModal,
			showArticleTagModal,
			showNewsTagModal,
			showFinancialYearModal,
			createParams
		} = this.props

		switch (type) {
			case 'person':
			case 'person_with_email':
				const [firstName, ...lastParts] = inputValue.split(' ')

				requestAnimationFrame(() => {
					showContactModal({
						contact: {
							first_name: firstName,
							last_name: lastParts?.join(' ') || '',
							type: ContactType.PERSON,
							...createParams
						},
						onSubmit: this.onResourceModalSubmit
					})
				})
				break
			case 'company':
			case 'company_with_email':
				requestAnimationFrame(() => {
					showContactModal({
						contact: { name: inputValue, type: ContactType.COMPANY, ...createParams },
						onSubmit: this.onResourceModalSubmit
					})
				})
				break
			case 'contact':
			case 'contact_with_email':
				requestAnimationFrame(() => {
					showContactTypeModal({
						onSubmit: (contactType) => {
							const [firstName, ...lastParts] = inputValue.split(' ')

							showContactModal({
								contact: {
									first_name: firstName,
									last_name: lastParts?.join(' ') || '',
									name: inputValue,
									...createParams,
									type: contactType
								},
								onSubmit: this.onResourceModalSubmit
							})
						}
					})
				})
				break
			case 'project':
				requestAnimationFrame(() => {
					showProjectModal({
						project: {
							name: inputValue,
							...createParams,
						},
						contactDisabled: true,
						onSubmit: this.onResourceModalSubmit,
					})
				})
				break
			case 'deal':
				requestAnimationFrame(() => {
					showDealModal({
						deal: { name: inputValue, ...createParams },
						contactDisabled: true,
						projectDisabled: Boolean(createParams?.project_id),
						onSubmit: this.onResourceModalSubmit,
					})
				})
				break
			case 'contact_group':
				requestAnimationFrame(() => {
					showContactGroupModal({
						contactGroup: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
					})
				})
				break
			case 'project_tag':
				requestAnimationFrame(() => {
					showProjectTagModal({
						projectTag: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
					})
				})
				break
			case 'work_type':
				requestAnimationFrame(() => {
					showWorkTypeModal({
						workType: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
					})
				})
				break
			case 'document_tag':
				requestAnimationFrame(() => {
					showDocumentTagModal({
						documentTag: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
						onDelete: this.onResourceModalDelete
					})
				})
				break
			case 'playbook':
				this.props.history.push(RouteHelper.process(ERoute.PATH_PLAYBOOKS_CREATE))
				this.props.closeTaskModal()
				break
			case 'sequence':
				this.props.history.push(RouteHelper.process(ERoute.PATH_SEQUENCES_CREATE))
				this.props.closeContactEnrollmentModal()
				break
			case 'account':
				window.location.assign(`/auth/ponto`);
				break
			case 'help_center':
				this.props.history.push(RouteHelper.process(ERoute.PATH_HELP_CENTERS))
				break
			case 'news_center':
				this.props.history.push(RouteHelper.process(ERoute.PATH_NEWS_CENTERS))
				break
			case 'article_tag':
				requestAnimationFrame(() => {
					showArticleTagModal({
						helpCenterId: this.props.params.help_center_id,
						articleTag: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
						onDelete: this.onResourceModalDelete
					})
				})
				break
			case 'news_tag':
				requestAnimationFrame(() => {
					showNewsTagModal({
						newsCenterId: this.props.params.news_center_id,
						newsTag: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
						onDelete: this.onResourceModalDelete
					})
				})
				break
			case 'financial_year':
				requestAnimationFrame(() => {
					showFinancialYearModal({
						financialYear: { name: inputValue, ...createParams },
						onSubmit: this.onResourceModalSubmit,
					})
				})
				break
			case 'expense_category':
				requestAnimationFrame(() => {
					this.props.showExpenseCategoryModal({
						category: { name: inputValue, ...createParams },
						onSubmit: this.onExpenseCategoryModalSubmit,
					})
				})
				break
			default:
				throw Error(`[onCreateOption] Unsupported resource type ${type} given`)
		}
	}

	onAddOption(e) {
		e.stopPropagation()
		this.onCreateOption('')
	}

	onEditOption(e, option) {
		e.stopPropagation()

		if (option) {
			const id = option.value

			const {
				type,
				showContactModal,
				showProjectModal,
				showProjectTagModal,
				showDealModal,
				showDealStageModal,
				showContactGroupModal,
				showWorkTypeModal,
				showDocumentTagModal,
				showArticleTagModal,
				showNewsTagModal,
				showFinancialYearModal,
				createParams
			} = this.props

			switch (type) {
				case 'person':
				case 'person_with_email':
					requestAnimationFrame(() => {
						showContactModal({
							contact: { id: id },
							onSubmit: this.onResourceModalSubmit
						})
					})
					break
				case 'company':
				case 'company_with_email':
					requestAnimationFrame(() => {
						showContactModal({
							contact: { id: id },
							onSubmit: this.onResourceModalSubmit
						})
					})
					break
				case 'contact':
				case 'contact_with_email':
					requestAnimationFrame(() => {
						showContactModal({
							contact: { id: id },
							onSubmit: this.onResourceModalSubmit
						})
					})
					break
				case 'project':
					requestAnimationFrame(() => {
						showProjectModal({
							project: { id: id },
							contactDisabled: true,
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'deal':
					requestAnimationFrame(() => {
						showDealModal({
							deal: { id: id },
							contactDisabled: true,
							projectDisabled: Boolean(createParams?.project_id),
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'deal_stage':
					requestAnimationFrame(() => {
						showDealStageModal({
							dealStage: { id: id },
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'contact_group':
					requestAnimationFrame(() => {
						showContactGroupModal({
							contactGroup: { id: id },
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'project_tag':
					requestAnimationFrame(() => {
						showProjectTagModal({
							projectTag: { id: id },
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'work_type':
					requestAnimationFrame(() => {
						showWorkTypeModal({
							workType: { id: id },
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'document_tag':
					requestAnimationFrame(() => {
						showDocumentTagModal({
							documentTag: { id: id },
							onSubmit: this.onResourceModalSubmit,
							onDelete: this.onResourceModalDelete
						})
					})
					break
				case 'playbook':
					this.props.closeTaskModal()
					this.props.history.push(RouteHelper.process(ERoute.PATH_PLAYBOOK, { id: id }))
					break
				case 'sequence':
					this.props.closeContactEnrollmentModal()
					this.props.history.push(RouteHelper.process(ERoute.PATH_SEQUENCE, { id: id }))
					break
				case 'help_center':
					this.props.history.push(RouteHelper.process(ERoute.PATH_HELP_CENTER, { id: id }))
					break
				case 'news_center':
					this.props.history.push(RouteHelper.process(ERoute.PATH_NEWS_CENTER, { id: id }))
					break
				case 'article_tag':
					requestAnimationFrame(() => {
						showArticleTagModal({
							helpCenterId: this.props.params.help_center_id,
							articleTag: { id: id },
							onSubmit: this.onResourceModalSubmit,
							onDelete: this.onResourceModalDelete
						})
					})
					break
				case 'news_tag':
					requestAnimationFrame(() => {
						showNewsTagModal({
							newsCenterId: this.props.params.news_center_id,
							newsTag: { id: id },
							onSubmit: this.onResourceModalSubmit,
							onDelete: this.onResourceModalDelete
						})
					})
					break
				case 'financial_year':
					requestAnimationFrame(() => {
						showFinancialYearModal({
							financialYear: { id: id },
							onSubmit: this.onResourceModalSubmit,
						})
					})
					break
				case 'expense_category':
					// Default categories are not editable
					if (!option.category?.editable) return

					requestAnimationFrame(() => {
						this.props.showExpenseCategoryModal({
							category: { id: id },
							onSubmit: this.onExpenseCategoryModalSubmit,
						})
					})
					break
				default:
					throw Error(`[onEditOption] Unsupported resource type ${type} given`)
			}
		}
	}

	formatCreateLabel(inputValue: string) {
		const { type, t } = this.props

		switch (type) {
			case 'contact':
			case 'contact_with_email':
				return t('ResourceCreatablePowerSelect::Create contact "{{input}}"', { input: inputValue })
			case 'person':
			case 'person_with_email':
				return t('ResourceCreatablePowerSelect::Create person "{{input}}"', { input: inputValue })
			case 'company':
			case 'company_with_email':
				return t('ResourceCreatablePowerSelect::Create company "{{input}}"', { input: inputValue })
			case 'project':
				return t('ResourceCreatablePowerSelect::Create project "{{input}}"', { input: inputValue })
			case 'user':
				return t('ResourceCreatablePowerSelect::Invite team member "{{input}}"', { input: inputValue })
			case 'deal':
				return t('ResourceCreatablePowerSelect::Create deal "{{input}}"', { input: inputValue })
			case 'board':
				return t('ResourceCreatablePowerSelect::Create board "{{input}}"', { input: inputValue })
			case 'board_list':
				return t('ResourceCreatablePowerSelect::Create board list "{{input}}"', { input: inputValue })
			case 'contact_group':
				return t('ResourceCreatablePowerSelect::Create contact group "{{input}}"', { input: inputValue })
			case 'project_tag':
				return t('ResourceCreatablePowerSelect::Create tag "{{input}}"', { input: inputValue })
			case 'work_type':
				return t('ResourceCreatablePowerSelect::Create work type "{{input}}"', { input: inputValue })
			case 'document_tag':
				return t('ResourceCreatablePowerSelect::Create tag "{{input}}"', { input: inputValue })
			case 'playbook':
				return t('ResourceCreatablePowerSelect::Create playbook "{{input}}"', { input: inputValue })
			case 'sequence':
				return t('ResourceCreatablePowerSelect::Create sequence "{{input}}"', { input: inputValue })
			case 'account':
				return t('ResourceCreatablePowerSelect::Add account')
			case 'help_center':
				return t('ResourceCreatablePowerSelect::Add help center')
			case 'news_center':
				return t('ResourceCreatablePowerSelect::Add news center')
			case 'article_tag':
				return t('ResourceCreatablePowerSelect::Create tag "{{input}}"', { input: inputValue })
			case 'news_tag':
				return t('ResourceCreatablePowerSelect::Create tag "{{input}}"', { input: inputValue })
			case 'financial_year':
				return t('ResourceCreatablePowerSelect::Create financial year "{{input}}"', { input: inputValue })
			case 'expense_category':
				return t('ResourceCreatablePowerSelect::Create category "{{input}}"', { input: inputValue })
			default:
				throw Error(`Unsupported resource type ${type} given`)
		}
	}

	onResourceModalSubmit(resource: any) {
		const { type, isMulti } = this.props
		const { valueResources } = this.state

		let updatedValueResources = []
		const valueIndex = valueResources?.findIndex(valueResource => valueResource.id === resource.id)

		if (valueIndex > -1) {
			updatedValueResources = [...valueResources]

			updatedValueResources[valueIndex] = resource
		} else {
			updatedValueResources = valueResources ? [resource, ...valueResources] : [resource]
		}

		this.setState({ valueResources: updatedValueResources }, () => {
			switch (type) {
				case 'company':
				case 'company_with_email':
				case 'person':
				case 'person_with_email':
				case 'contact':
				case 'contact_with_email':
				case 'project':
				case 'project_tag':
				case 'user':
				case 'deal_stage':
				case 'deal':
				case 'work_type':
				case 'board':
				case 'board_list':
				case 'contact_group':
				case 'document_tag':
				case 'playbook':
				case 'sequence':
				case 'account':
				case 'help_center':
				case 'news_center':
				case 'article_tag':
				case 'news_tag':
				case 'financial_year':
					if (isMulti) {
						this.props.onChange(updatedValueResources.map(resource => resource.id), updatedValueResources)
					} else {
						this.props.onChange(resource.id, resource)
					}
					break
				default:
					throw Error(`[onResourceModalSubmit] Unsupported resource type ${type} given`)
			}
		})
	}

	onExpenseCategoryModalSubmit(category: ExpenseCategory, deleted?: boolean) {
		const { isMulti, value, onChange, isGroupHeadingSelectable } = this.props
		const values: string[] = Array.isArray(value) ? value : (value ? [value] : [])
		const isNew = !this.getResources().some(resource => resource.id === category.id)

		if (deleted) {
			this.setState(prevState => ({
				defaultResources: (prevState.defaultResources || []).filter(resource => resource.id !== category.id),
				valueResources: prevState.valueResources ? prevState.valueResources.filter(resource => resource.id !== category.id) : null,
			}), () => {
				if (!values.includes(category.id)) return

				if (isMulti) {
					this.setExpenseCategoryValues(values.filter(id => id !== category.id))
				} else {
					onChange(null, null)
				}
			})
			return
		}

		this.setState(prevState => {
			const defaultResources = prevState.defaultResources || []

			return {
				// New categories are appended, same as the expense modal did
				defaultResources: isNew ? [...defaultResources, category] : defaultResources.map(resource => resource.id === category.id ? category : resource),
				valueResources: prevState.valueResources ? prevState.valueResources.map(resource => resource.id === category.id ? category : resource) : null,
			}
		}, () => {
			// Select newly created categories, parent categories only when they are selectable
			if (!isNew || (!category.parent_id && !isGroupHeadingSelectable)) return

			if (isMulti) {
				this.setExpenseCategoryValues([...values, category.id])
			} else {
				onChange(category.id, category)
			}
		})
	}

	onResourceModalDelete(resource: any) {
		const { type, isMulti } = this.props
		const { valueResources } = this.state

		let updatedValueResources = valueResources?.filter(valueResource => valueResource.id !== resource.id)

		this.setState({ valueResources: updatedValueResources }, () => {
			switch (type) {
				case 'document_tag':
				case 'article_tag':
				case 'news_tag':
					if (isMulti) {
						this.props.onChange(updatedValueResources.map(resource => resource.id), updatedValueResources)
					} else {
						this.props.onChange(null, null)
					}
					break
				default:
					throw Error(`[onResourceModalDelete] Unsupported resource type ${type} given`)
			}
		})
	}

	isValidNewOption(inputValue: string, value: any, options: OptionsType<any>) {
		const { type } = this.props

		if (inputValue === '') return false

		switch (type) {
			case 'contact':
			case 'contact_with_email':
			case 'person':
			case 'person_with_email':
			case 'company':
			case 'company_with_email':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.CONTACT)
			case 'project':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PROJECT)
			case 'project_tag':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'user':
				// It doesn't make sense to be able to invite users (also returns no value for user_id since it is an invite)
				return false
			case 'deal':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.DEAL)
			case 'deal_stage':
				return false
			case 'work_type':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'board':
				return false
			case 'board_list':
				return false
			case 'contact_group':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'document_tag':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.DOCUMENT)
			case 'playbook':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PLAYBOOK)
			case 'sequence':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PLAYBOOK)
			case 'account':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.BANK)
			case 'help_center':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.HELP_CENTER)
			case 'news_center':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.NEWS_CENTER)
			case 'article_tag':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.HELP_CENTER)
			case 'news_tag':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.NEWS_CENTER)
			case 'financial_year':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'expense_category':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.EXPENSE)
			default:
				throw Error(`[isValidNewOption] Unsupported resource type ${type} given`)
		}
	}

	getComponents(): Partial<SelectComponents<any, any>> {
		const { type } = this.props

		switch (type) {
			case 'contact':
			case 'person':
			case 'company':
				return ContactSelectComponents
			case 'project':
				return ProjectSelectComponents
			case 'contact_with_email':
			case 'company_with_email':
			case 'person_with_email':
				return ContactEmailIndicatorSelectComponents
			case 'document_tag':
				return DocumentTagSelectComponents
			case 'article_tag':
				return ArticleTagSelectComponents
			case 'news_tag':
				return NewsTagSelectComponents
			case 'project_tag':
				return ProjectTagSelectComponent
			case 'expense_category':
				return ExpenseCategorySelectComponents
			default:
				return ResourceSelectComponents
		}

		return {}
	}

	getUpsertModeEnabled() {
		const { type } = this.props
		switch (type) {
			case 'board':
			case 'board_list':
				return false
			case 'contact':
			case 'person':
			case 'company':
			case 'contact_with_email':
			case 'company_with_email':
			case 'person_with_email':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.CONTACT)
			case 'project':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PROJECT)
			case 'project_tag':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PROJECT)
			case 'deal':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.DEAL)
			case 'deal_stage':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'contact_group':
			case 'work_type':
				return UserworkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'document_tag':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.DOCUMENT)
			case 'playbook':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.PLAYBOOK)
			case 'sequence':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SEQUENCE)
			case 'article_tag':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.HELP_CENTER)
			case 'news_tag':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.NEWS_CENTER)
			case 'account':
			case 'help_center':
			case 'news_center':
			case 'user':
				return false
			case 'financial_year':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.SETTING)
			case 'expense_category':
				return UserWorkspaceSettingHelper.hasScope(UserWorkspaceSettingScope.EXPENSE)
		}
	}

	render() {
		const { type, isDisabled, isClearable, isValidNewOption, isMulti, placeholder, styles } = this.props
		const { isLoadingValueResource, isLoadingDefaultResources, isLoadingSearchResources } = this.state

		const options = this.getOptions()
		const selectedOptions = this.getSelectedOptions()

		return (
			<CreatableSelect
				options={options}
				value={selectedOptions}
				placeholder={placeholder}
				onChange={this.onChange}
				onCreateOption={this.onCreateOption}
				onInputChange={this.onInputChange}
				formatCreateLabel={this.formatCreateLabel}
				isDisabled={isDisabled}
				isClearable={isClearable}
				isLoading={isLoadingValueResource || isLoadingDefaultResources || isLoadingSearchResources}
				isValidNewOption={isValidNewOption ? isValidNewOption : this.isValidNewOption}
				allowCreateWhileLoading={false}
				theme={ReactSelectTheme}
				styles={styles}
				isMulti={isMulti}
				components={this.getComponents()}
				onFocus={this.onInputFocus}
				onAddClick={this.onAddOption}
				onEditClick={this.onEditOption}
				upsertModeEnabled={this.getUpsertModeEnabled()}
				{...(type === 'expense_category' ? {
					isOptionSelected: this.isOptionSelected,
					isOptionDisabled: (option) => Boolean(option.placeholder),
					filterOption: this.filterOption,
					hideSelectedOptions: false,
					closeMenuOnSelect: !isMulti,
					// Custom props, available through selectProps in ExpenseCategorySelectComponents
					isGroupHeadingSelectable: Boolean(this.props.isGroupHeadingSelectable),
					onGroupHeadingClick: this.onGroupHeadingClick,
					isGroupSelected: (groupValue: string) => this.isOptionSelected({ value: groupValue }),
				} : {})}
			/>
		)
	}
}


const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
	return {
		showContactModal: (options) => dispatch(showContactModal(options)),
		showProjectModal: (options) => dispatch(showProjectModal(options)),
		showUserWorkspaceSettingModal: (options) => dispatch(showUserWorkspaceSettingModal(options)),
		showDealModal: (options) => dispatch(showDealModal(options)),
		showDealStageModal: (options) => dispatch(showDealStageModal(options)),
		showContactGroupModal: (options) => dispatch(showContactGroupModal(options)),
		showContactTypeModal: (options) => dispatch(showContactTypeModal(options)),
		showWorkTypeModal: (options) => dispatch(showWorkTypeModal(options)),
		showDocumentTagModal: (options) => dispatch(showDocumentTagModal(options)),
		showArticleTagModal: (options) => dispatch(showArticleTagModal(options)),
		showNewsTagModal: (options) => dispatch(showNewsTagModal(options)),
		closeTaskModal: () => dispatch(closeTaskModal()),
		closeContactEnrollmentModal: () => dispatch(closeContactEnrollmentModal()),
		showProjectTagModal: (options) => dispatch(showProjectTagModal(options)),
		showFinancialYearModal: (options) => dispatch(showFinancialYearModal(options)),
		showExpenseCategoryModal: (options) => dispatch(showExpenseCategoryModal(options)),
	}
}

export { ResourceCreatablePowerSelectClass }
export default withRouter(connect(null, mapDispatchToProps)(withTranslation()(ResourceCreatablePowerSelectClass)) as any) as any